module.exports = __webpack_public_path__ + "static/media/instagram.9fa794db.png";